import React from 'react';
import { FormGroup, Label, Input, FormFeedback, FormText } from 'reactstrap';
import Required from '../Required';
import { withTranslation } from 'react-i18next';

const CustomFormInput = ({
  id,
  label,
  onChange,
  value,
  helperText,
  invalid,
  error,
  t,
  ...props
}) => {
  return (
    <FormGroup>
      <Label for={id}>
        {t(label)} {props.required && <Required />}
      </Label>
      <Input
        id={id}
        name="text"
        type={props.type}
        placeholder={props.placeholder}
        onChange={onChange}
        value={value}
        className={props.inputClass}
        invalid={invalid ? true : false}
      />
      {props.accessory}
      {helperText && <FormText>{t(helperText)}</FormText>}
      {invalid && <FormFeedback>{t(error)}</FormFeedback>}
    </FormGroup>
  );
};

CustomFormInput.defaultProps = {
  type: 'text',
};

export default withTranslation('app')(CustomFormInput);
